import { useTranslation } from 'react-i18next'
import { Col, Row } from 'antd'

import FormatPrice from '@/components/FormatPrice'
import { DeleteBorderlessIcon } from '@/components/Icons'

interface ProductComparisonCardProps {
  productList: {
    categoryName: string
    materialName: string
    materialNumber: string
    listPrice: number
    currencyUnit: string
    image: string
    displayListPrice: boolean
  }[]
  hasExtraProduct?: boolean
  removeItemFunc?: (materialNumber: string) => void
}

function ProductComparisonCard({
  productList,
  hasExtraProduct = false,
  removeItemFunc,
}: ProductComparisonCardProps) {
  const { t } = useTranslation()

  if (productList.length === 1) {
    const {
      categoryName,
      image,
      materialName,
      listPrice,
      currencyUnit,
      displayListPrice,
    } = productList[0]

    return (
      <div className="product-comparison-card__wrapper--single">
        <Row className="fadeIn-2">
          <Col
            className="product-comparison-card__img"
            lg={12}
            md={12}
            sm={24}
            xl={12}
            xs={24}
          >
            <img alt={materialName || ''} src={image} />
          </Col>
          <Col
            className="product-comparison-card__main-content"
            lg={12}
            md={12}
            sm={24}
            xl={12}
            xs={24}
          >
            <h4>{categoryName}</h4>
            <h3>{materialName}</h3>
            <div className="product-comparison-card__list-price">
              <div className="product-comparison-card__list-price__left">
                {t('productDetails.priceBox.listingPrice')}
              </div>
              <div className="product-comparison-card__list-price__right">
                {displayListPrice && listPrice
                  ? (
                    <FormatPrice
                      currencyUnit={currencyUnit}
                      price={listPrice}
                    />
                  )
                  : (
                    t('productCard.onRequest')
                  )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  if (productList.length > 1) {
    return (
      <div className="product-comparison-card__wrapper--multi">
        <Row gutter={50}>
          {productList.map((product) => (
            <Col
              key={`${product.materialNumber}-${product.materialName}`}
              className="fadeIn-2 product-comparison-card__wrapper"
              lg={8}
              md={8}
              sm={24}
              xl={8}
              xs={24}
            >
              <div className="product-comparison-card__img">
                <img alt={product.materialName} src={product.image} />
              </div>
              <h4 className="product-comparison-card__category-name--multi">
                {product.categoryName}
              </h4>
              <h3 className="product-comparison-card__name--multi">
                {product.materialName}
              </h3>
              {hasExtraProduct && (
                <button
                  className="remove-product-btn"
                  type="button"
                  onClick={() => removeItemFunc?.(product.materialNumber)}
                >
                  <DeleteBorderlessIcon className="remove-cart-item__icon" /> {t('cart.removeItem')}
                </button>
              )}
            </Col>
          ))}
        </Row>
      </div>
    )
  }

  return null
}

export default ProductComparisonCard
